import { render } from "./SectionPartner.vue?vue&type=template&id=c47328ba&scoped=true"
import script from "./SectionPartner.vue?vue&type=script&lang=js"
export * from "./SectionPartner.vue?vue&type=script&lang=js"

import "./SectionPartner.vue?vue&type=style&index=0&id=c47328ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c47328ba"]])

export default __exports__